document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct();
})
document.addEventListener('dkLabProductComparerProductsChanged', function() {
    customProduct();
});

document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function() {
    customProduct();
});

document.addEventListener('dmproductsDone', function () {
    customProduct();

    setTimeout(function () {
        $('.dmproducts.slider.dm-done').each(function (index) {
            var $original = $(this);

            if ($original.attr('data-custom-slider-created') === '1') {
                return;
            }

            var $products = $original.children('.product');

            if (!$products.length) {
                return;
            }

            if (typeof $.fn.slick !== 'function') {
                console.warn('Slick není načtený');
                return;
            }

            $original.attr('data-custom-slider-created', '1');

            // Původní blok očistíme od rozbité Slick inicializace
            $original
                .removeClass('slick-initialized slick-slider slick-dotted')
                .removeAttr('role');

            // Vytvoříme úplně nový čistý wrapper
            var $slider = $('<div class="dmProductsCustomSlider products products-page products-block"></div>');

            // Do něj dáme klony produktů
            $products.each(function () {
                var $product = $(this).clone(false, false);

                $product
                    .removeClass('slick-slide slick-current slick-active slick-cloned')
                    .removeAttr('data-slick-index')
                    .removeAttr('aria-hidden')
                    .removeAttr('tabindex')
                    .removeAttr('role')
                    .removeAttr('style');

                $slider.append($product);
            });

            $original.after($slider);
            $original.addClass('dmProductsOriginalHidden').hide();

            $slider.slick({
                accessibility: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: false,
                autoplay: false,
                autoplaySpeed: 5000,
                dots: true,
                arrows: true,
                infinite: false,
                adaptiveHeight: false,
                responsive: [
                    { breakpoint: 1199, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false } },
                    { breakpoint: 300, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false } }
                ]
            });

            $slider.slick('setPosition');
        });
    }, 300);
});
 


function customProduct() {

    if (!$('.product').length) return;

    var codes = [];
    var productsMap = {};

    $('.product').each(function () {
        var $product = $(this);
        var sku = $product.find('span[data-micro="sku"]').text().trim();
        if(!$(this).find('.customCode').length){
            $(this).find('.image').append(`
                <span class="customCode">${translation('kod')}: ${$(this).find('span[data-micro="sku"]').text().trim()}</span>    
        `   )
        }

        
        if (sku) {
            codes.push({ code: sku });
            productsMap[sku] = $product;
        }
        var formatPriceDPH = formatPrice($product.find('div[data-micro="offer"]').attr('data-micro-price'));
        var formatDPHprice = $product.find('.prices .price-additional').text().trim().replace(translation('bezDPH'), '').trim();

        if(formatPriceDPH === formatDPHprice){
            $($product).find('.price-additional').text(translation('osvobozeno'))
        }
           
        if($product.find('.dkLabComparerProductDiv').length){
            !$product.find('.p-bottom>div[data-micro="offer"]').append($product.find('.dkLabComparerProductDiv'))
        };
        if ($product.find('.product-appendix').length) {
            $product.find('.p-in-in').append($product.find('.product-appendix'));
        }

        if ($product.find('.availability-amount').length) {
            $product.find('.availability-amount')
                .text(
                    $product.find('.availability-amount').text()
                        .replace('(', '')
                        .replace(')', '')
                        .replace('>', '> ')
                )
                .attr(
                    'style',
                    $product.find('.availability > span:not(.availability-amount)').attr('style')
                );
        }

        if ($product.find('.stars-wrapper').length) {
            if (!$product.find('.stars-wrapper .counter').length) {
                $product.find('.stars-wrapper').append(
                    '<span class="counter">(' +
                    $product.find('.stars-wrapper').attr('data-micro-rating-count') +
                    'x)</span>'
                );
            }
        } else if ($product.find('.stars-placeholder').length && 
                $product.find('.stars-placeholder').is(':empty')) {
            $product.find('.stars-placeholder').html(`
                <div class="stars-wrapper" data-micro-rating-value="0" data-micro-rating-count="0">
                    <span class="stars star-list">
                        <span class="star star-off"></span>
                        <span class="star star-off"></span>
                        <span class="star star-off"></span>
                        <span class="star star-off"></span>
                        <span class="star star-off"></span>
                    </span>
                    <span class="counter">(0x)</span>
                </div>
            `);
        }

        $product.find('.p-bottom > div[data-micro="offer"]').prepend(
            $product.find('.availability')
        );

        if ($product.find('.image .price-standard').length) {

            $product.find('.flag.flag-discount').html(
                $product.find('.flag.flag-discount').html()
                    .replace(/^\s*od\s*/i, '')
                    .replace(/\s*až\s*/i, '')
                    .trim()
            );

            if (!$product.find('.superPrice').length) {
                $product.find('.prices')
                    .addClass('superPrice')
                    .prepend('<span class="title">' + akcniCena + '</span>')
                    .prepend($product.find('.image .price-standard'));
            } else {
                // záměrně prázdné – zachováno
            }
        }

        const availabilityText = $product.find('.availability > span:not(.availability-amount)')
            .text()
            .trim()
            .toLowerCase();
       
        const deliveryDate = getDeliveryDateByAvailability(availabilityText);
        if (!deliveryDate) return;
        const formatted = formatDeliveryDate(deliveryDate);
        if(!$product.find('.availability .deliveryDate').length){
            $product.find('.availability').append(
            `<div class="deliveryDate">${formatted}</div>`
        );
        }
        

        /* ========================================================= */

    });

    /* ======================= AJAX – CENY ======================= */

    if (!codes.length) return;

    $.ajax({
        url: 'https://www.akce-incomputer.cz/api-get-prices.php',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify({
            Source: 'SK',
            data: codes
        }),
       success: function (response) {
            if (!response || !response.data) return;
       // console.log(response)
            response.data.forEach(function (item) {

                var $product = $('.product')
                    .filter(function () {
                        return $(this).find('[data-micro="sku"]').text().trim() === item.code;
                    })
                    .first();

                if (!$product.length) return;

                applyPricesToProduct($product, item);
            });
        },
        error: function (xhr) {
            console.error('AJAX chyba ceny:', xhr.responseText);
        }
    }).done(function(){
        initTooltips();
    });
}


function applyPricesToProduct($product, price) {
    /* 1️⃣ musí být nepřihlášen */
    if (!isCustomerNotRegistered()) return;
    /* 3️⃣ login cena nesmí být nula nebo null */
    if (price.price_login === 0 || price.price_login === null) return;
    var $offer = $product.find('.p-bottom > div[data-micro="offer"]');
    /* 3️⃣ login cena musí být vyšší než běžná cena */
    var basePrice = parseFloat($offer.attr('data-micro-price'));
   // console.log(price.price_login)
  //  console.log(basePrice)
    if (price.price_login >= basePrice ) return;
    var $pBottom = $product.find('.p-bottom');
    if (!$pBottom.length) return;
    var html = `
        <div class="loginPrice">
            <strong class="price-login">
                ${formatPrice(price.price_login)}
            </strong>
            <span class="title">${translation('pro')} <a href="${registrovaneUrl}">${translation('registrovane')}</a></span><span class="info show-tooltip" data-original-title="${tooltipText}"></span>
        </div>
    `;
    if(!$product.find('.loginPrice').length){
        $pBottom.append(html);
    }
    
}




function formatPrice(value) {
    return Number(value).ShoptetFormatAsCurrency();
}

function isCustomerNotRegistered() {
    try {
        return (
            typeof getShoptetDataLayer === 'function' &&
            getShoptetDataLayer('customer') &&
            getShoptetDataLayer('customer').registered === false
        );
    } catch (e) {
        return false;
    }
}

$('html').on('click', '.products .product', function (e) {
    if ($(e.target).closest('a, button').length) {
        return;
    }
    const href = $(this).find('a.image').attr('href');
    if (href) {
        window.location.href = href;
    }
    })
    .on('mouseenter', '.products .product', function () {
        $(this).addClass('hover');
    })
    .on('mouseleave', '.products .product', function () {
        $(this).removeClass('hover');
});